import React, { forwardRef } from "react";
import { InputMask } from "primereact/inputmask";

const GenericInputPhone = forwardRef((props, ref) => {
  return <InputMask mask="9999-9999" {...props} ref={ref} />;
});

export default GenericInputPhone;
